import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { namespace, Action } from "vuex-class";

import { storeModules } from "../../../store";
import TimeLineComponent from "../timeline";
import historyTypesStore from "../../../store/history/history-types.store";
import { HistoryMapper } from "../../../models/history";
import { DataHelper } from "../../../utils/data-helper";
import { HistoryServices } from "../../../services";
import EventBus from "../../../utils/event-bus";
import { EVENT_BUS } from "../../../common/constants";

const HistoryAction = namespace(storeModules.History, Action);

@Component({
  template: require("./template.html"),
  components: {
    timeline: TimeLineComponent
  }
})
class TimeLinePopoverComponent extends Vue {
  @Prop() index: number;

  @Prop() searchData: any;

  @Prop() dataPropKey: string;

  @Prop({ default: "Date", type: [String] })
  datetimeKey: string;

  @Prop({ default: 60 })
  scrollbarOffset: number;

  @Prop({ default: null })
  fixHeight: number;

  @Prop() data: any;
  dtSubSearchFilter: any;
  dtTimeLineData: any[];
  pagination: any;
  dtIsLoading: boolean = false;

  private historyService = new HistoryServices();

  constructor() {
    super();
    this.dtTimeLineData = null;
    this.pagination = null;
  }

  mounted() {
    console.log(222);
    this.dtSubSearchFilter = DataHelper.deepClone(this.searchData);
    this.handleOpen();
  }

  get TimeLineData() {
    return this.dtTimeLineData || [];
  }

  filterCreater(record, pattern: string) {
    return new Date(record[this.datetimeKey]).toDateString() === pattern;
  }

  getDateFilter(record: any) {
    return new Date(record[this.datetimeKey]).toDateString();
  }

  handleOpen() {
    this.pagination = null;
    var param = this.dtSubSearchFilter;
    param["PageIndex"] = 1;

    this.dtTimeLineData = [];
    this.dtIsLoading = true;
    this.storeGetListChildren({
      param,
      childId: this.data.PersonId,
      key: this.dataPropKey,
      index: this.index
    })
      .then(data => {
        this.dtIsLoading = false;
        this.pagination = data.pagination;
        const dates = data.listOfItems.map(record =>
          this.getDateFilter(record)
        );

        this.dtTimeLineData = Array.from(new Set(dates)).map(
          (dateString: any) => {
            const children = data.listOfItems.filter(item =>
              this.filterCreater(item, dateString)
            );
            return new HistoryMapper(dateString, children);
          }
        );
      })
      .catch(error => {
        this.$message.error(error);
        this.dtIsLoading = false;
      });
  }

  private scrollToTop() {
      const container = this.$el.getElementsByClassName('timeline')[0]
      if (container) {
          container.scrollTo({
              top: 0,
              behavior: 'smooth'
          })
      }
  }

  changePage(page) {
    this.dtTimeLineData = [];
    var param = this.dtSubSearchFilter;

    param["PageIndex"] = page;
      this.scrollToTop();
    this.dtIsLoading = true;
    this.storeGetListChildren({
      param,
      childId: this.data.PersonId,
      key: "listOfPropertyPropertyProspectHistory",
      index: this.index
    })
      .then(data => {
        this.dtIsLoading = false;
        this.pagination = data.pagination;
        const dates = data.listOfItems.map(record =>
          this.getDateFilter(record)
        );

        this.dtTimeLineData = Array.from(new Set(dates)).map(
          (dateString: any) => {
            const children = data.listOfItems.filter(item =>
              this.filterCreater(item, dateString)
            );
            return new HistoryMapper(dateString, children);
          }
        );
      })
      .catch(error => {
        this.$message.error(error);
        this.dtIsLoading = false;
      });
  }

  handleDelete(record) {
    this.$confirm(this.$t('DELETEWARNINGMESSAGES').toString(), this.$t('CONFIRMATION').toString(), {
        confirmButtonText: this.$t('DELETE').toString(),
        cancelButtonText: this.$t('CANCEL').toString(),
        type: "error",
        confirmButtonClass: "el-button--danger",
    }).then(() => {
        this.dtIsLoading = true;
        this.historyService.deleteHistory({
            Id: record.RootId,
            HisDetailId: record.HisDetailId
        }).then(data => {
            this.fetchData();
            this.handleOpen();
            this.dtIsLoading = false;
        }).catch((err) => {
            this.dtIsLoading = false;
        });
    }).catch(() => {
        // CANCEL
    });
  }

  fetchData () {
    EventBus.$emit(EVENT_BUS.HISTORY.UPDATE_HISTORY_LIST);
  }

  @HistoryAction(historyTypesStore.Get.LIST_CHILDREN)
  storeGetListChildren: (
    payload: {
      param: any;
      childId: number;
      key: string;
      index: number;
    }
  ) => Promise<any>;

  closePopover() {
    this.$emit("update:open", false);
  }

  beforeDestroy() {
    this.dtSubSearchFilter = null;
    this.dtTimeLineData = null;
    this.pagination = null;
  }
}

export default TimeLinePopoverComponent;
